import React, { useState, useEffect } from "react";
import { Text, Plus } from "lucide-react";

export default function AdminTexts() {
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [data, setData] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    text: "",
    text_en: "",
  });

  useEffect(() => {
    fetchTexts();
  }, []);

  const fetchTexts = async () => {
    const res = await fetch("/api/admin/assets/texts.php");
    const texts = await res.json();

    setData(texts || []);
  };

  async function handleSubmit(e) {
    e.preventDefault();

    const url = "/api/admin/assets/edit_text.php";

    const payload = { ...formData, id: editingId };

    await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    fetchTexts();
    resetForm();
  }

  function resetForm() {
    setShowForm(false);
    setEditingId(null);
    setFormData({
      title: "",
      text: "",
      text_en: "",
    });
  }

  function editProject(_text) {
    setFormData({
      title: _text.title,
      text: _text.text,
      text_en: _text.text_en,

    });

    setEditingId(_text.id);
    setShowForm(true);
  }

  return (
    <section>
      <div>
                <div className="container-xl">
                  <div className="bg-white rounded shadow p-4">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h1 className="cat-title h3 fw-bold text-dark d-flex align-items-center gap-2">
                          <Text className="text-primary" />
                          Textes
                        </h1>
                        <p className="text-secondary mb-0">
                          Modifier des textes
                        </p>
                      </div>
                    </div>
                  {showForm && (
                    <div className="bg-primary bg-opacity-10 p-4 rounded mt-4 w-100">
                      <h3 className="fw-semibold mb-3">Editer Texte</h3>
      
                      <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                              <div className="col-12">
                                <label className="form-label fw-medium" htmlFor='title'>Nom</label>
                                <p className="">{formData.title}</p>
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='text'>Texte FR</label>
                                <textarea
                                    className="form-control"
                                    rows="4"
                                    name="text"
                                    value={formData.text}
                                    required
                                    onChange={(e) =>
                                        setFormData({ ...formData, text: e.target.value })
                                    }
                                />
                              </div>
                              <div className="col-12 col-md-6">
                                <label className="form-label fw-medium" htmlFor='text_en'>Texte EN</label>
                                <textarea
                                    className="form-control"
                                    rows="4"
                                    name="text_en"
                                    value={formData.text_en}
                                    required
                                    onChange={(e) =>
                                        setFormData({ ...formData, text_en: e.target.value })
                                    }
                                />
                              </div>
                            </div>
      
                            <div className="d-flex gap-2 mt-4">
                              <button type="submit" className="btn btn-primary">
                                {editingId ? "Modifier" : "Enregistrer"}
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setShowForm(false);
                                  setEditingId(null);
                                  setFormData({
                                    title: "",
                                    text: "",
                                    text_en: ""
                                  });
                                }}
                                className="btn btn-secondary"
                              >
                                Annuler
                              </button>
                            </div>
                          </form>
                        </div>
                      )}
                      <div className="col g-3 pt-4">
                        {data.map((text, i) => {
      
                          return (
                            <div className="col mb-3" key={text.id}>
                              <div className="card border-dark bg-white rounded shadow p-3 h-100">
                                <div className="border-bottom pb-2 mb-2">
                                  <h2 className="h4 fw-bold mb-4">{text.title}</h2>
                                  <div className="row mt-2">
                                    <div className="col-6">
                                      <p className="text text-start small mb-0" style={{whiteSpace: "pre-line" }}>{text.text}</p>
                                    </div>
                                    <div className="col-6">
                                      <p className="text-muted text-start small mb-0" style={{whiteSpace: "pre-line" }}>{text.text_en}</p>
                                    </div>
                                  </div>
                                </div>
                                          <div className="d-flex gap-1">
                                            <button
                                              onClick={() => editProject(text)}
                                              className="btn btn-sm btn-outline-dark"
                                              title="Modifier"
                                            >
                                              Modifier
                                            </button>
                                          </div>
                                  </div>
                            </div>
                          );
                        })}
                      </div>
                  </div>
                </div>
              </div>
    </section>
  );
}